import React from 'react';
import { Typography } from '@mui/material';

/**
 * Admit source template
 */
export const AdmitSourceTemplate: React.FC<{ source?: string }> = ({ source }) => {
  return (
    <Typography variant="body2" sx={{ fontSize: '0.8rem' }}>
      {source || '-'}
    </Typography>
  );
};

export default AdmitSourceTemplate;
